// ScrollContext.tsx
import React, { createContext, useContext, RefObject } from 'react';

interface ScrollContextProps {
    scrollContainerRef: RefObject<HTMLDivElement>;
}

const ScrollContext = createContext<ScrollContextProps | undefined>(undefined);

export const ScrollProvider: React.FC<{ scrollContainerRef: RefObject<HTMLDivElement>; children: React.ReactNode }> = ({ scrollContainerRef, children }) => {
    return (
        <ScrollContext.Provider value={{ scrollContainerRef }}>
            {children}
        </ScrollContext.Provider>
    );
};

export const useScrollContext = (): ScrollContextProps => {
    const context = useContext(ScrollContext);
    if (!context) {
        throw new Error('useScrollContext must be used within a ScrollProvider');
    }
    return context;
};
